export interface Airport {
  code: string;
  name: string;
  city: string;
  country: string;
}

export const COUNTRIES = [
  "Japan",
  "Philippines",
  "Vietnam",
  "Indonesia",
  "Thailand",
  // "Myanmar",
  // "Cambodia",
  "Nepal",
  "India",
  "Bangladesh",
  // "Sri Lanka",
  // "China",
  // "South Korea",
  // "Malaysia",
  // "Singapore",
  // "United States",
  // "United Kingdom",
  // "Australia",
  // "Canada",
  // "Germany",
  // "France",
  // "UAE",
  // "Saudi Arabia",
  // "Qatar",
  // "Turkey",
  // "Brazil",
  // "Mexico",
] as const;

export const AIRPORTS: Airport[] = [
  // Japan
  {
    code: "NRT",
    name: "Narita International",
    city: "Tokyo",
    country: "Japan",
  },
  { code: "HND", name: "Haneda", city: "Tokyo", country: "Japan" },
  {
    code: "KIX",
    name: "Kansai International",
    city: "Osaka",
    country: "Japan",
  },
  { code: "NGO", name: "Chubu Centrair", city: "Nagoya", country: "Japan" },
  { code: "FUK", name: "Fukuoka", city: "Fukuoka", country: "Japan" },
  { code: "CTS", name: "New Chitose", city: "Sapporo", country: "Japan" },
  { code: "OKA", name: "Naha", city: "Okinawa", country: "Japan" },

  // Philippines
  {
    code: "MNL",
    name: "Ninoy Aquino International",
    city: "Manila",
    country: "Philippines",
  },
  {
    code: "CEB",
    name: "Mactan-Cebu International",
    city: "Cebu",
    country: "Philippines",
  },
  {
    code: "DVO",
    name: "Francisco Bangoy International",
    city: "Davao",
    country: "Philippines",
  },
  {
    code: "CRK",
    name: "Clark International",
    city: "Clark",
    country: "Philippines",
  },

  // Vietnam
  {
    code: "SGN",
    name: "Tan Son Nhat International",
    city: "Ho Chi Minh City",
    country: "Vietnam",
  },
  {
    code: "HAN",
    name: "Noi Bai International",
    city: "Hanoi",
    country: "Vietnam",
  },
  {
    code: "DAD",
    name: "Da Nang International",
    city: "Da Nang",
    country: "Vietnam",
  },

  // Indonesia
  {
    code: "CGK",
    name: "Soekarno-Hatta International",
    city: "Jakarta",
    country: "Indonesia",
  },
  {
    code: "DPS",
    name: "Ngurah Rai International",
    city: "Bali",
    country: "Indonesia",
  },
  {
    code: "SUB",
    name: "Juanda International",
    city: "Surabaya",
    country: "Indonesia",
  },

  // Thailand
  { code: "BKK", name: "Suvarnabhumi", city: "Bangkok", country: "Thailand" },
  { code: "DMK", name: "Don Mueang", city: "Bangkok", country: "Thailand" },
  {
    code: "CNX",
    name: "Chiang Mai International",
    city: "Chiang Mai",
    country: "Thailand",
  },

  // Myanmar
  // { code: "RGN", name: "Yangon International", city: "Yangon", country: "Myanmar" },
  // { code: "MDL", name: "Mandalay International", city: "Mandalay", country: "Myanmar" },

  // Cambodia
  // { code: "PNH", name: "Phnom Penh International", city: "Phnom Penh", country: "Cambodia" },
  // { code: "REP", name: "Siem Reap International", city: "Siem Reap", country: "Cambodia" },

  // Nepal
  {
    code: "KTM",
    name: "Tribhuvan International",
    city: "Kathmandu",
    country: "Nepal",
  },

  // India
  {
    code: "DEL",
    name: "Indira Gandhi International",
    city: "New Delhi",
    country: "India",
  },
  {
    code: "BOM",
    name: "Chhatrapati Shivaji Maharaj",
    city: "Mumbai",
    country: "India",
  },
  {
    code: "BLR",
    name: "Kempegowda International",
    city: "Bangalore",
    country: "India",
  },
  {
    code: "MAA",
    name: "Chennai International",
    city: "Chennai",
    country: "India",
  },

  // Bangladesh
  {
    code: "DAC",
    name: "Hazrat Shahjalal International",
    city: "Dhaka",
    country: "Bangladesh",
  },
  {
    code: "CGP",
    name: "Shah Amanat International",
    city: "Chittagong",
    country: "Bangladesh",
  },

  // Sri Lanka
  // { code: "CMB", name: "Bandaranaike International", city: "Colombo", country: "Sri Lanka" },

  // China
  // { code: "PEK", name: "Beijing Capital International", city: "Beijing", country: "China" },
  // { code: "PVG", name: "Shanghai Pudong International", city: "Shanghai", country: "China" },
  // { code: "CAN", name: "Guangzhou Baiyun International", city: "Guangzhou", country: "China" },

  // South Korea
  // { code: "ICN", name: "Incheon International", city: "Seoul", country: "South Korea" },
  // { code: "GMP", name: "Gimpo International", city: "Seoul", country: "South Korea" },
  // { code: "PUS", name: "Gimhae International", city: "Busan", country: "South Korea" },

  // Malaysia
  // { code: "KUL", name: "Kuala Lumpur International", city: "Kuala Lumpur", country: "Malaysia" },

  // Singapore
  // { code: "SIN", name: "Changi", city: "Singapore", country: "Singapore" },

  // United States
  // { code: "JFK", name: "John F. Kennedy International", city: "New York", country: "United States" },
  // { code: "LAX", name: "Los Angeles International", city: "Los Angeles", country: "United States" },
  // { code: "SFO", name: "San Francisco International", city: "San Francisco", country: "United States" },
  // { code: "ORD", name: "O'Hare International", city: "Chicago", country: "United States" },

  // United Kingdom
  // { code: "LHR", name: "Heathrow", city: "London", country: "United Kingdom" },
  // { code: "LGW", name: "Gatwick", city: "London", country: "United Kingdom" },

  // Australia
  // { code: "SYD", name: "Kingsford Smith", city: "Sydney", country: "Australia" },
  // { code: "MEL", name: "Melbourne", city: "Melbourne", country: "Australia" },

  // Canada
  // { code: "YYZ", name: "Toronto Pearson International", city: "Toronto", country: "Canada" },
  // { code: "YVR", name: "Vancouver International", city: "Vancouver", country: "Canada" },

  // Germany
  // { code: "FRA", name: "Frankfurt", city: "Frankfurt", country: "Germany" },
  // { code: "MUC", name: "Munich", city: "Munich", country: "Germany" },

  // France
  // { code: "CDG", name: "Charles de Gaulle", city: "Paris", country: "France" },

  // UAE
  // { code: "DXB", name: "Dubai International", city: "Dubai", country: "UAE" },
  // { code: "AUH", name: "Abu Dhabi International", city: "Abu Dhabi", country: "UAE" },

  // Saudi Arabia
  // { code: "RUH", name: "King Khalid International", city: "Riyadh", country: "Saudi Arabia" },
  // { code: "JED", name: "King Abdulaziz International", city: "Jeddah", country: "Saudi Arabia" },

  // Qatar
  // { code: "DOH", name: "Hamad International", city: "Doha", country: "Qatar" },

  // Turkey
  // { code: "IST", name: "Istanbul", city: "Istanbul", country: "Turkey" },

  // Brazil
  // { code: "GRU", name: "Guarulhos International", city: "Sao Paulo", country: "Brazil" },

  // Mexico
  // { code: "MEX", name: "Benito Juárez International", city: "Mexico City", country: "Mexico" },
];

export const getAirportsByCountry = (country: string): Airport[] => {
  return AIRPORTS.filter((a) => a.country === country);
};

export const getAirportLabel = (code: string): string => {
  const airport = AIRPORTS.find((a) => a.code === code);
  if (!airport) return code;
  return `${airport.code} - ${airport.city} (${airport.name})`;
};
